import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GameSelectorNavStyled, { GameSelectorNext, GameSelectorPrev, SVG } from './GameSelectorNav.styled';
import { onChangeGameUp, onChangeGameDown } from '../../../state-actions/onChangeGameLevel';

const mapStateToProps = state => ({
  currentGame: state.saved.gameLevel,
  gamesTotal: state.gameData.length,
});

const mapDispatchToProps = dispatch => ({
  onChangeGameUp: level => dispatch(onChangeGameUp(level)),
  onChangeGameDown: level => dispatch(onChangeGameDown(level))
});

const GameSelectorNav = ({ currentGame, gamesTotal, onChangeGameUp, onChangeGameDown }) => {
  const handleChangeUp = (currentGame) => onChangeGameUp(currentGame);
  const handleChangeDown = (currentGame) => onChangeGameDown(currentGame);

  return (
    <GameSelectorNavStyled>
      {currentGame >= 1 && <GameSelectorPrev onClick={handleChangeDown} title="Prev"><SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125"><path d="M70.9 2.5c1.4 0 2.9.5 4 1.6 2.2 2.2 2.2 5.7 0 7.9L37 50l37.9 37.9c2.2 2.2 2.2 5.7 0 7.9s-5.7 2.2-7.9 0L25.1 54c-1.1-1.1-1.6-2.5-1.6-4s.6-2.9 1.6-4L67 4.1c1.1-1.1 2.5-1.6 3.9-1.6z" /></SVG></GameSelectorPrev>}
      {currentGame < (gamesTotal - 1) && <GameSelectorNext onClick={handleChangeUp} title="Next"><SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125"><path d="M29.1 97.5c-1.4 0-2.9-.5-4-1.6-2.2-2.2-2.2-5.7 0-7.9L63 50 25.1 12.1c-2.2-2.2-2.2-5.7 0-7.9S30.8 2 33 4.1L74.9 46c1.1 1.1 1.6 2.5 1.6 4s-.6 2.9-1.6 4L33 95.9c-1.1 1.1-2.5 1.6-3.9 1.6z" /></SVG></GameSelectorNext>}
    </GameSelectorNavStyled>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(GameSelectorNav);

GameSelectorNav.propTypes = {
  currentGame: PropTypes.number.isRequired,
  gamesTotal: PropTypes.number.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/molecules/GameSelectorNav/GameSelectorNav.js